// fake data from marvel.fandom.com

export const comics = [
    {
        id: 1,
        title: 'Spider-Man',
        issue: 1,
        cover: 'https://imgur.com/LRZk3KZ.jpg',
        series: 'Amazing Spider Man Vol 1',
        originalPrice: 10,
        salePrice: 4.99,
        rating: 4.5,
        description:
            'With the Parker household desperate for money following the death of Ben Parker, Peter Parker decides to continue in show business as Spider-Man. However, not only does he find it impossible to cash his paycheck (made out to Spider-Man), but the irrational editorials by J. Jonah Jameson in the Daily Bugle effectively quelch his career. Besides denouncing Spider-Man as a...',
        quote: '"Oh dear, I certainly hope they find that horrible Spider-Man and lock him up before he can do any harm!" -Aunt May',
    },
    {
        id: 2,
        title: 'Duel to the Death with the Vulture!',
        issue: 2,
        cover: 'https://imgur.com/NA6WV7K.jpg',
        series: 'Amazing Spider Man Vol 1',
        originalPrice: 10,
        salePrice: null,
        rating: 4,
        description:
            'New York City is being terrorized by a new criminal called the Vulture. He is equipped with artificial wings that allow him to swoop down on his victims, snatch their valuables, and fly away before they know what is happening. Nobody has been able to photograph him, and J. Jonah Jameson needs pictures to illustrate his Vulture feature...',
        quote: '"Well well! So teacher\'s pet is gonna help the nice little doctor with some experiments this week-end, eh? While us other dumbheads waste time having dates and livin\' it up!" -Flash Thompson',
    },
    {
        id: 3,
        title: 'Spider-Man Versus Doctor Octopus',
        issue: 3,
        cover: 'https://imgur.com/BYyEFNw.jpg',
        series: 'Amazing Spider Man Vol 1',
        originalPrice: 10,
        salePrice: null,
        rating: 5,
        description:
            'Spider-Man catches Charlie and his two pals robbing a warehouse. Surprising them with his Spider Signal light, he quickly overcomes them and webs them up for the police. Meanwhile, atomic scientist Otto Octavius, known to his colleagues as Doctor Octopus because of the unique set of four remote-controlled "arms" he invented for handling radioactive material, is hard at...',
        quote: '"Now, watch me trap a spider in a web of my own -- a web made of my new-found arms! Your strength is merely that of a spider, but mine is the energy of an atom, born of a nuclear accident!" -Doctor Octopus',
    },
    {
        id: 4,
        title: 'Nothing Can Stop... the Sandman!',
        issue: 4,
        cover: 'https://imgur.com/m5YzwmT.jpg',
        series: 'Amazing Spider Man Vol 1',
        originalPrice: 10,
        salePrice: null,
        rating: 4,
        description:
            "Spider-Man sees a few punks casing a jewelry store and webs them up before they can rob it. However, the thugs threaten to sue Spider-Man for assault and battery! Spider-Man must flee when they call the cops, since all the evidence makes him look guilty. Spider-Man blames Jameson for this treatment and leaves him a little souvenir in his office. After leaving Jameson's office, Spider-Man runs into the Sandman on a rooftop. Sandman gets the best of Spider-Man...",
        quote: '"Who, that coward? He\'s probably hidin\' with his head under a desk somewhere!" -Flash Thompson',
    },
    {
        id: 5,
        title: 'Marked for Destruction by Dr. Doom!',
        issue: 5,
        cover: 'https://imgur.com/5RpcRnk.jpg',
        series: 'Amazing Spider Man Vol 1',
        originalPrice: 10,
        salePrice: null,
        rating: 4.5,
        description:
            'After a report by J. Jonah Jameson about the "menace" of Spider-Man, Peter (in order to avoid any suspicion that he\'s really Spider-Man) speaks negatively about his alter ego, earning him harsh words from Flash Thompson. Meanwhile, Dr. Doom had seen this same report, and decided that after surviving his last encounter battling the Fantastic Four, that perhaps Spider-Man would make for a good partner to eliminate...',
        quote: "\"It's a cinch you don't, panty-waist! You'd probably faint if you ever caught sight of 'im!\" -Flash Thompson, in reference to Spider-Man",
    },
    {
        id: 6,
        title: 'Face-to-Face with... the Lizard!',
        issue: 6,
        cover: 'https://imgur.com/nwVhYSp.jpg',
        series: 'Amazing Spider Man Vol 1',
        originalPrice: 10,
        salePrice: null,
        rating: 4,
        description:
            'When reports of a humanoid-lizard (naturally dubbed "The Lizard") come out of Florida, Daily Bugle publisher J. Jonah Jameson issues a challenge to Spider-Man: Defeat the Lizard. Hearing about this, Peter goes to see what Jameson\'s intentions are. He learns that Jameson only issued the challenge to...',
        quote: '"Don\'t make me laugh! If there really is a giant lizard down south, Spider-Man will never tackle him! He\'d rather stay here, fighting two-bit hoods and making a rep for himself!" -J. Jonah Jameson',
    },

    {
        id: 7,
        title: 'The Fantastic Four',
        issue: 1,
        cover: 'https://imgur.com/FU6QXO0.jpg',
        series: 'Fantastic Four Vol 1',
        originalPrice: 10,
        salePrice: 4.99,
        rating: 4,
        description:
            'A shadowy figure fires a flare out of a window. The flare forms the words "The Fantastic Four!" Susan Storm is having tea with a friend. When she sees the flare, she turns invisible, gets into a cab, and offers the surprised driver a banknote when she reaches her destination. Ben Grimm is trying to find a coat that fits him. A clerk in the haberdashery sees the flare. Grimm bursts out of the too-small door, rips a manhole out of the street, follows the sewers, and bursts out when...',
        quote: '"It is the first time I have found it necessary to give the signal! I pray it will be the last!" -Mister Fantastic',
    },
    {
        id: 8,
        title: 'The Fantastic Four Meet the Skrulls from Outer Space!',
        issue: 2,
        cover: 'https://imgur.com/Pez2y2Z.jpg',
        series: 'Fantastic Four Vol 1',
        originalPrice: 10,
        salePrice: null,
        rating: 4.5,
        description:
            'The Thing attacks an oil platform off the Texas shore. The Invisible Girl steals a valuable gem from a jewelry store. The Human Torch melts a statue when a town unveils it. Mister Fantastic shuts down a power plant. These impostors meet afterward and reveal how they used their shape-shifting abilities and alien technology...',
        quote: 'Maybe I am a monster! I look like one—and sometimes I feel like one! -The Thing',
    },
    {
        id: 9,
        title: 'The Menace of the Miracle Man',
        issue: 3,
        cover: 'https://imgur.com/LnPtCpb.jpg',
        series: 'Fantastic Four Vol 1',
        originalPrice: 10,
        salePrice: null,
        rating: 5,
        description:
            'The Miracle Man is performing at a theater. He points out the Fantastic Four and mocks them. He claims his powers are far greater than theirs and demonstrates by growing into a giant, turning into a cloud, and controlling thunder and lightning. He even upstages the Thing in a test of...',
        quote: '"Why must we always fight among ourselves? What\'s wrong with us?" -Mister Fantastic',
    },
    {
        id: 10,
        title: 'The Coming of... Sub-Mariner!',
        issue: 4,
        cover: 'https://imgur.com/K8lsJsQ.jpg',
        series: 'Fantastic Four Vol 1',
        originalPrice: 10,
        salePrice: null,
        rating: 4.5,
        description:
            "The Human Torch has quit the team. Reed, Sue, and Ben use the Fantasti-Car to search the city for him. Johnny, though, has gone to Swanson's Garage to work on cars. Ben, on a hunch, goes to the garage. Unable to use his flame because of the gasoline around him, Johnny faces an angry Ben without his power. Ben backs him into a corner, but, before...",
        quote: '"Well! Here is a prize worth catching!" -Prince Namor, the Sub-Mariner',
    },
    {
        id: 11,
        title: 'Prisoners of Doctor Doom!',
        issue: 5,
        cover: 'https://imgur.com/e04STGe.jpg',
        series: 'Fantastic Four Vol 1',
        originalPrice: 10,
        salePrice: null,
        rating: 4,
        description:
            'Johnny, while reading an issue of The Incredible Hulk, compares Ben to the monster. Ben grabs the comic, but Johnny sets it afire. Reed and Sue stop them before they come to blows. The lights go out, despite their emergency generator. Doctor Doom, in a helicopter, drops a net over the Baxter Building. When Doom calls out to them, Reed recognizes the voice: Victor von Doom, an...',
        quote: '"Doctor Doom!? Who—? What is he?" -Invisible Girl',
    },
    {
        id: 12,
        title: 'Captives of the Deadly Duo!',
        issue: 6,
        cover: 'https://imgur.com/zf0hiRq.jpg',
        series: 'Fantastic Four Vol 1',
        originalPrice: 10,
        salePrice: null,
        rating: 3,
        description:
            "After scouting for Dr. Doom, the Human Torch returns to the Fantastic Four's Baxter Building headquarters to report on his lack of success in finding Doom. He arrives just as his teammates are reading fan mail. When Reed gets a letter from a fan who is presently staying at a nearby hospital, Reed stretches out his body to pay the boy a personal visit. Meanwhile, Ben gets a mocking letter from...",
        quote: '"You\'ve gone soft on Sub-Mariner--our arch enemy!" -The Human Torch',
    },

    {
        id: 13,
        title: 'The Coming of the Avengers!',
        issue: 1,
        cover: 'https://imgur.com/ynawZCP.jpg',
        series: 'Avengers Vol 1',
        originalPrice: 10,
        salePrice: 4.99,
        rating: 5,
        description:
            'Loki, having been previously captured by Thor, is being held prisoner at the Isle of Silence in Asgard. His physical form may be confined there, but by means of thought projection his disembodied self travels to Earth in search of revenge. He spots Thor in his human identity of Dr. Donald Blake but resists defeating him as it would be a hollow victory compared to defeating him as Thor.',
        quote: "\"I'm sick of bein' hunted and hounded! I'd rather be with you than against you! So, whether you like it or not, I'm joining the... the... Hey! What are you callin' yourselves?\" -Hulk",
    },
    {
        id: 14,
        title: 'The Avengers Battle... the Space Phantom',
        issue: 2,
        cover: 'https://imgur.com/4okBNwI.jpg',
        series: 'Avengers Vol 1',
        originalPrice: 10,
        salePrice: null,
        rating: 3.5,
        description:
            "Iron Man, Thor, and the Hulk are awaiting Ant-Man and the Wasp in Tony Stark's library so they can begin their meeting. There is already tension among the ranks of this new super-team as Thor and Hulk bicker. Before anything can come of it, Ant-Man and the Wasp make a sudden entrance, seemingly appearing out of nowhere. Ant-Man, (now using the name Giant-Man) explains by showing the team his new size-changing capsules.",
        quote: '"If I can destroy the Avengers single-handed, then no power on Earth can stop the total invasion of my people!" -Space Phantom',
    },
    {
        id: 15,
        title: 'The Avengers meet Sub-Mariner!',
        issue: 3,
        cover: 'https://imgur.com/DM1VkWI.jpg',
        series: 'Avengers Vol 1',
        originalPrice: 10,
        salePrice: null,
        rating: 2,
        description:
            'At their next meeting, the Avengers decide they need to find the Hulk before he causes more trouble. Iron Man uses his image projector device to communicate with the Fantastic Four, Spider-Man, and the X-Men to ask if they have spotted him, but he has no luck. Thor comes up with the smart idea of asking Rick Jones to help find the Hulk. They contact him, and Rick sets out into the desert to an area where he could be.',
        quote: "\"I tell you we've got to find the Hulk! So long as he's running wild, there's no telling what he'll do!\" -Iron Man",
    },
    {
        id: 16,
        title: 'Captain America Joins... The Avengers!',
        issue: 4,
        cover: 'https://imgur.com/R4bKyKd.jpg',
        series: 'Avengers Vol 1',
        originalPrice: 10,
        salePrice: null,
        rating: 5,
        description:
            'After escaping his battle with the Avengers, Namor angrily continues his search for his missing people. He eventually finds his way to the North Sea, where he discovers a tribe of Inuit people worshiping a dead man frozen in a block of ice. Still angry at humanity Namor approaches the Inuit, causing them to flee as he throws the ice block into the water. It drifts away, slowly beginning to thaw.',
        quote: '"Unhand me! I cannot bear physical contact with primitive beings!" -Vuk',
    },
    {
        id: 17,
        title: 'The Invasion of The Lava Men!',
        issue: 5,
        cover: 'https://imgur.com/rQDl0YH.jpg',
        series: 'Avengers Vol 1',
        originalPrice: 10,
        salePrice: null,
        rating: 4,
        description:
            "The Avengers return to their mansion to inspect the damage caused by the battle with the Hulk. They disband for the time being and Captain America teaches Rick Jones some acrobatic maneuvers. Days later, a mysterious high-pitched sound destroys a computer in one of Tony Stark's Long Island factories and Iron Man is informed. Meanwhile, Giant-Man and the Wasp are conducting experiments inside a large anthill. They are also affected by...",
        quote: '"You are a coward, Molto! When we sent you to the surface months ago, you were defeated by the one named Thor! Now you fear them all!" -Jinku',
    },
    {
        id: 18,
        title: 'The Mighty Avengers Meet The Masters Of Evil!',
        issue: 6,
        cover: 'https://imgur.com/3Wcpo7F.jpg',
        series: 'Avengers Vol 1',
        originalPrice: 10,
        salePrice: null,
        rating: 4.5,
        description:
            "En route to respond to the Teen Brigade's distress call, Captain America gives the other Avengers a demonstration of skill with his shield. Cap thanks Iron Man for upgrading his shield with transistors, making the shield even easier to use. He thinks of Bucky and begins to dwell on the past.",
        quote: '"Your loyalty and trust have been a great comfort for me! They\'ve given me the will to go on! But something else has too! A hunger for revenge! On my oath as an Avenger, I shall devote my life, if need be, to finding the one who caused Bucky\'s death! Only then will I be able to find peace!" -Captain America',
    },

    {
        id: 19,
        title: 'X-Men',
        issue: 1,
        cover: 'https://imgur.com/RSLFBg5.jpg',
        series: 'X-Men Vol 1',
        originalPrice: 10,
        salePrice: 4.99,
        rating: 3.5,
        description:
            "At Xavier's School for Gifted Youngsters in Westchester County, New York, Professor Charles Xavier summons his students telepathically. When the Beast, Angel, Iceman, and Cyclops arrive, he puts them through a series of exercises to hone their mutant talents. Xavier then introduces them to a new student, Marvel Girl, to whom he explains the purpose of his school: his students do receive an education, but they are also the first line of defense against evil mutants.",
        quote: '" Class is now in session! Tardiness will be punished!" -Professor X',
    },
    {
        id: 20,
        title: 'No One Can Stop the Vanisher!',
        issue: 2,
        cover: 'https://imgur.com/K2iseiO.jpg',
        series: 'X-Men Vol 1',
        originalPrice: 10,
        salePrice: null,
        rating: 4.5,
        description:
            "Professor Xavier telepathically orders his students to return to the school. Once they return to the mansion, Professor Xavier informs them that there is a new super-villain with mutant powers calling himself the Vanisher. Earlier in the day, he had robbed the national bank by using his teleportation powers to escape from the bank's security guards. Professor Xavier sends his students off on extra training missions to prepare them for the upcoming fight with the Vanisher.",
        quote: '"The greatest power on Earth is the magnificent power we all of us possess... the power of the human brain!" -Professor X',
    },
    {
        id: 21,
        title: 'Beware of the Blob!',
        issue: 3,
        cover: 'https://imgur.com/Lu2EbYB.jpg',
        series: 'X-Men Vol 1',
        originalPrice: 10,
        salePrice: null,
        rating: 4,
        description:
            "Professor Xavier interrupts the X-Men's latest training session to inform them that he has mentally detected a new mutant nearby. The X-Men find the mutant known as the Blob working at a carnival. They invite the Blob into the school so that Professor Xavier can test his powers. Afterwards, Professor Xavier invites the Blob to join the X-Men, but he refuses. In an attempt to maintain the X-Men's secret identities, Professor Xavier tries to mind-wipe the Blob, but he is able to escape.",
        quote: "\"Of all the girls I've ever met, she is the one I'd give my heart to -- but I don't dare! Not while I possess my dread power!\" -Cyclops",
    },
    {
        id: 22,
        title: 'The Brotherhood of Evil Mutants!',
        issue: 4,
        cover: 'https://imgur.com/K0nrQpG.jpg',
        series: 'X-Men Vol 1',
        originalPrice: 10,
        salePrice: null,
        rating: 5,
        description:
            'The X-Men are in the middle of their latest training session. Marvel Girl is given the task of lifting a lid from a box using her telekinetic powers. Once it is opened, she finds a cake stashed inside! Professor Xavier explains that it has been one year since classes first started at the school, and he felt that the date should be celebrated.',
        quote: '"But is it necessary to plant such fear in the hearts of the people, Magneto?" -Scarlet Witch',
    },
    {
        id: 23,
        title: 'Trapped: One X-Man',
        issue: 5,
        cover: 'https://imgur.com/cQa1ePQ.jpg',
        series: 'X-Men Vol 1',
        originalPrice: 10,
        salePrice: null,
        rating: 4.5,
        description:
            "The X-Men's last battle against Magneto and his Brotherhood of Evil Mutants injured the Professor, seemingly destroying his telepathic abilities. They return Professor Xavier to the mansion so that he can get some rest and hopefully regain his powers. The X-Men ponder what they will do without Professor Xavier's help when they hear Marvel Girl's parents arrive for a visit. The X-Men quickly change into their civilian clothes so they can greet their visitors. They excuse Professor Xavier's absence and give Jean Grey's parents a tour of the mansion. The party heads...",
        quote: '"You\'ve proven you can think and act for yourselves!! Your training period is over!! Congratulations, my X-Men!!" -Professor X',
    },
    {
        id: 24,
        title: 'Sub-Mariner Joins the Evil Mutants!',
        issue: 6,
        cover: 'https://imgur.com/ouAnwWs.jpg',
        series: 'X-Men Vol 1',
        originalPrice: 10,
        salePrice: null,
        rating: 3,
        description:
            "Professor Xavier reads a newspaper article about the Sub-Mariner. He wonders whether or not the Sub-Mariner is a mutant. Meanwhile, Magneto and his Brotherhood of Evil Mutants are at their new headquarters on an island, pondering the same thing. Magneto tries to recruit the Sub-Mariner by projecting his astral form under the ocean. Professor Xavier does the same thing from the mansion, but he hides his astral form when he senses Magneto's astral form nearby.",
        quote: '"Not since I lost my heart to Sue Storm have I seen such a beauty as the Scarlet Witch!" -Namor, the Sub-Mariner',
    },
];
